import { Fragment, Suspense } from 'react';
import { Outlet } from 'react-router';
import Header from '@/components/Header/index';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/Sidebar/app-sidebar';
import { useLoadingGif } from '@/hooks/useLoadingGif';

export default function MainLayout() {
  const LoadingGif = useLoadingGif();

  return (
    <Fragment>
      <div className="min-h-screen bg-main overflow-x-hidden">
        <SidebarProvider>
          {/* Sidebar */}
          <div className="h-full">
            <AppSidebar />
          </div>

          {/* Main Content */}
          <SidebarInset>
            <div className="transition-all duration-300 min-h-screen">
              {/* Header */}
              <Header />

              {/* Page Content */}
              <main className="px-[1rem] md:px-[3rem] pb-[2rem]">
                <Suspense
                  fallback={
                    <div className="flex items-center justify-center h-screen">
                      <img src={LoadingGif} alt="Loading" className="w-[12rem] h-[12rem]" />
                    </div>
                  }
                >
                  <Outlet />
                </Suspense>
              </main>
            </div>
          </SidebarInset>
        </SidebarProvider>
      </div>
    </Fragment>
  );
}
